import { ViewEncapsulation } from '@angular/core';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import * as _ from 'underscore';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
	selector: 'app-r10-demographics',
	templateUrl: './r10-demographics.component.html',
	styleUrls: ['./r10-demographics.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class R10DemographicsComponent extends BaseWidgetComponent implements OnInit {
	@ViewChild('chartElement', { static: true }) graphElement: ElementRef;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: any;
	@Input() legend: any;
	@Input() colorsconfig: any;
	@Input() sectionclass: string;
	@Input() uikitresponseconfig: any;
	@Input() customchartconfiguration: any;
	@Input() nodatamessage: any;

	public showLoad = true;
	public hasData = false;
	public widgetDataSubscription;
	public reloadSubscription;
	public chartArrData = {};
	public activeIndex = 0;
	public primaryColor: any;
	public tertiaryColor: any;
	public secondary: any;
	public responseData: any;
	public seriesObj = [];
	public tempArr = [];
	public colorPalette: ColorPalette;
	public totalDemogImpClicks: object[] = [];
	public chartConfig: any;
	public seriesObjVal: any;
	public checkedVal = 'false';
	public currentLegendItem = '';
	public total = 0;
	public baseConfig: any;
	public isR10: boolean = false;
	public legendData: Array<String> = [];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		super(analyticsService);
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.chartConfig = { ...this.chartConfig };
	}

	ngOnInit() {
		this.legend = JSON.parse(decodeURI(this.legend));
		this.uikitresponseconfig = this.uikitresponseconfig ? JSON.parse(decodeURI(this.uikitresponseconfig)) : [];
		this.customchartconfiguration = this.customchartconfiguration
			? JSON.parse(decodeURI(this.customchartconfiguration))
			: {};
		this.baseConfig = {
			chartConfig: this.customchartconfiguration.chartConfig
		};
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.isR10 = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		if (!this.nodatamessage || this.nodatamessage === 'undefined' || this.nodatamessage === 'null') {
			this.nodatamessage = 'No Data to Display';
		}
		super.ngOnInit();
	}

	requestData() {
		this.showLoad = true;
		this.hasData = false;
		this.currentLegendItem = this.legend[0].value;
		this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
			this.showLoad = false;
			if (response.success && response.data.length > 0) {
				this.hasData = true;
				this.responseData = response.data;
				this.buildSeriesObj(this.responseData);
				this.processResponseData(response.data);
				for (let i in this.legend) {
					this.legendData.push(this.legend[i]['value']);
				}
			} else {
				this.hasData = false;
			}
		});
	}

	onChangeEvent(event) {
		if (event === true) {
			this.currentLegendItem = 'clicks';
			this.processResponseData(this.responseData);
		} else {
			this.currentLegendItem = 'impressions';
			this.processResponseData(this.responseData);
		}
	}

	setLegendAndReDraw(legend: any) {
		this.currentLegendItem = legend;
		this.processResponseData(this.responseData);
	}

	processResponseData(response: any): void {
		const demographicDataGroupedByAge: any = _.groupBy(response, 'age_group');
		this.tempArr = [];
		let sumValue = 0;
		const ageGroupData = _.groupBy(response, 'age_group');
		let matrix_value: any = 0;
		// tslint:disable-next-line: forin
		for (const age in ageGroupData) {
			// tslint:disable-next-line: no-shadowed-variable
			matrix_value = ageGroupData[age].reduce((accumulator: any, currentValue: any): any => {
				return accumulator + Number(currentValue[this.currentLegendItem]);
			}, 0);
			sumValue += matrix_value;
		}

		for (const key in demographicDataGroupedByAge) {
			const obj = {};

			// tslint:disable-next-line: forin
			for (const index in demographicDataGroupedByAge[key]) {
				const gender = demographicDataGroupedByAge[key][index].gender;
				obj[gender + '%'] = demographicDataGroupedByAge[key][index][this.currentLegendItem]
					? Number(((demographicDataGroupedByAge[key][index][this.currentLegendItem] / sumValue) * 100).toFixed(2))
					: 0;
				obj[gender] = this.analyticsService.numberFormatter(
					demographicDataGroupedByAge[key][index][this.currentLegendItem]
						? demographicDataGroupedByAge[key][index][this.currentLegendItem]
						: 0
				);
				obj['value'] = demographicDataGroupedByAge[key][index][this.currentLegendItem]
					? demographicDataGroupedByAge[key][index][this.currentLegendItem]
					: 0;
				this.total = sumValue;
				obj['age_group'] = demographicDataGroupedByAge[key][index].age_group;
			}
			this.tempArr.push(obj);
		}
		this.seriesObjVal = this.tempArr;
		setTimeout(() => {
			if (this.hasData) {
				this.drawGraph();
			}
		});
	}

	buildSeriesObj(chartData: any): void {
		this.seriesObj = [];
		// tslint:disable-next-line: forin
		for (const chartItem of this.customchartconfiguration.chartConfig.series) {
			const seriesOb = {
				axisDataSource: [
					{
						dataType: 'number',
						displayName: chartItem.seriesName,
						readFrom: chartItem.readFrom,
						showInSeries: true,
						customProperties: [
							{
								keyName: 'male',
								readFrom: 'male'
							},
							{
								keyName: 'female',
								readFrom: 'female'
							},
							{
								keyName: 'value',
								readFrom: 'value'
							}
						]
					}
				],
				color: chartItem.colorConfig ? this.getColorFromColorConfiguration(chartItem.colorConfig) : chartItem.color,
				data: [],
				name: chartItem.seriesName,
				type: chartItem.type,
				borderRadius: 0,
				pointWidth: chartItem.pointWidth
			};
			this.seriesObj.push(seriesOb);
		}
	}

	getToolTipFormatter(): any {
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		if (this.isR10) {
			return function (): string {
				if (this.series.name === 'male') {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>% of Total</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block;'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.male}</div>
					</div>
				</div>`;
				} else if (this.series.name === 'female') {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%; color: #444444'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>% of Total</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block;'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.female}</div>
					</div>
				</div>`;
				} else {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%; color: #444444'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>% of Total</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div class = 'capitalize-text' style='width: 46%; display:inline-block;'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.value}</div>
					</div>
				</div>`;
				}
			};
		} else {
			return function (): string {
				if (this.series.name === 'male') {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%'>
						<div style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.male}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>percentage</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
				</div>`;
				} else if (this.series.name === 'female') {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%; color: #444444'>
						<div style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.female}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>percentage</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
				</div>`;
				} else {
					return `
				<div style='width: 9.5rem; padding: 3px'>
					<div style='width: 100%; color: #444444'>
						<div style='width: 46%; display:inline-block'>${this.series.name}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.x}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>${self.currentLegendItem}</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.point.value}</div>
					</div>
					<div style='width: 100%; color: ${this.color}'>
						<div style='width: 46%; display:inline-block'>percentage</div>
						<div style='width: 46%; display:inline-block; text-align: right'>${this.y}%</div>
					</div>
				</div>`;
				}
			};
		}
	}

	drawGraph() {
		const ageGroupData = Object.keys(_.groupBy(this.responseData, 'age_group'));
		const finalConfig = JSON.parse(JSON.stringify(this.baseConfig.chartConfig));
		finalConfig.series = this.seriesObj;
		finalConfig.xAxis[0].categories = ageGroupData;
		if (this.isR10) {
			let legendText = '';
			this.currentLegendItem == 'impressions' ? (legendText = 'Impressions') : (legendText = 'Clicks');
			finalConfig.yAxis[0].title.text = '% of Total <br>' + legendText;
		} else {
			finalConfig.yAxis[0].title.text = 'percentage of total' + ' ' + this.currentLegendItem;
		}
		finalConfig.toolTip.formatter = this.getToolTipFormatter();
		finalConfig.plotOptions.series.keys = ['y', 'male'];
		this.chartConfig = {
			chartConfig: finalConfig,
			responseConfig: this.uikitresponseconfig
		};
	}

	private getColorFromColorConfiguration(colorConfig: ColorConfig): string {
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, colorConfig.opacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, colorConfig.opacity);
		}
		return rgb;
	}
}
